<template lang="pug">
  modal(:title='modalTitle' @closeModal='closeModal')
    .column(v-if='success')
      .column.middle.center
        simple-svg(:filepath='checkIcon' width='42px' height='42px')
        h2.text-center.title-medium.m-top-2 {{ successMessage }}
    .column.m-top-2(v-else)
      tag-selector(
        :label='$t("krea.publishContentModal.keywordsLabel")'
        name='keywords'
        tagClass='keyword'
        :title='$t("krea.publishContentModal.keywordsPlaceholder", {keywordsAmount: 10 * (modalProps.availableLanguages || 1)})'
        :placeholder='$t("krea.publishContentModal.keywordsPlaceholder", {keywordsAmount: 10 * (modalProps.availableLanguages || 1)})'
        :tags='keywords'
        :updateMethod='editTags'
        :maxTags='30'
        maxHeight='150px'
      )
      .m-top-1.row.middle(v-if='showError')
        simple-svg.red-icon.m-right-05.red-stroke-icon(:filepath='errorIcon' width='16px' height='16px')
        h2.text-normal.red {{ $t("krea.publishContentModal.error") }}
      .row.middle.end.m-top-1
        button.secondary-button.m-right-2(@click='closeModal') {{ $t("krea.publishContentModal.cancel") }}
        button.primary-button(:disabled='!keywords.length' @click='submit')
          | {{ $t('krea.publishContentModal.save') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modal from '@/components/Modal'
import TagSelector from '@/components/Inputs/TagSelector'
import checkIcon from '@/assets/ic_check.svg'
import { i18n } from '../../main'
import errorIcon from '@/assets/ic_stop.svg'

export default {
  components: { Modal, TagSelector },
  data() {
    return {
      errorIcon,
      checkIcon,
      keywords: [],
      success: false,
      showError: false
    }
  },
  mounted() {
    this.keywords = this.modalProps.keywords || []
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.kreaEditKeywordsContentModal.props
    }),
    modalTitle() {
      if (this.success) return null
      else return i18n.t('krea.publishContentModal.editKeywordsTitle')
    },
    successMessage() {
      if (this.publishMode) return i18n.t('krea.publishContentModal.success')
      else return i18n.t('krea.publishContentModal.edited')
    }
  },
  methods: {
    ...mapActions([
      'hideElement',
      'setKreaEducationalContentKeywords',
      'setKreaEducationalContentStatus'
    ]),
    closeModal() {
      this.hideElement({ element: 'kreaEditKeywordsContentModal' })
    },
    editTags(newValue) {
      this.keywords = newValue
    },
    async submit() {
      this.showError = false
      const { success, error } = await this.setKreaEducationalContentKeywords({
        id: this.modalProps.contentId,
        keywords: this.keywords
      })
      if (success) {
        this.success = true
      } else {
        this.showError = true
        this.$notify({
          group: 'custom-toast',
          duration: 5000,
          type: 'error',
          text: error
        })
      }
      this.$emit('success')
    }
  }
}
</script>

<style lang="scss">
@import 'src/scss/variables/colors';

.ti-tag{
  &.keyword{
    background-color: $blue !important;
    span{
      color: $white;
    }
    .ti-icon-close {
      color: $white;
      margin-left: 5px;
    }
  }
}
</style>
